// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICardStatusMultiEmployersSummaryRecordDto
 */
export interface ICardStatusMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {number}
     * @memberof ICardStatusMultiEmployersSummaryRecordDto
     */
    total_active_cards?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardStatusMultiEmployersSummaryRecordDto
     */
    total_pending_activation_cards?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardStatusMultiEmployersSummaryRecordDto
     */
    total_closed_cards?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardStatusMultiEmployersSummaryRecordDto
     */
    total_lost_cards?: number;
    /**
     * 
     * @type {string}
     * @memberof ICardStatusMultiEmployersSummaryRecordDto
     */
    percentage_of_active_cards?: string;
    /**
     * 
     * @type {number}
     * @memberof ICardStatusMultiEmployersSummaryRecordDto
     */
    primary_cards_number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICardStatusMultiEmployersSummaryRecordDto
     */
    dependent_cards_number?: number;
}

/**
 * Check if a given object implements the ICardStatusMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfICardStatusMultiEmployersSummaryRecordDto(value: object): value is ICardStatusMultiEmployersSummaryRecordDto {
    return true;
}

export function ICardStatusMultiEmployersSummaryRecordDtoFromJSON(json: any): ICardStatusMultiEmployersSummaryRecordDto {
    return ICardStatusMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function ICardStatusMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICardStatusMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_active_cards': json['total_active_cards'] == null ? undefined : json['total_active_cards'],
        'total_pending_activation_cards': json['total_pending_activation_cards'] == null ? undefined : json['total_pending_activation_cards'],
        'total_closed_cards': json['total_closed_cards'] == null ? undefined : json['total_closed_cards'],
        'total_lost_cards': json['total_lost_cards'] == null ? undefined : json['total_lost_cards'],
        'percentage_of_active_cards': json['percentage_of_active_cards'] == null ? undefined : json['percentage_of_active_cards'],
        'primary_cards_number': json['primary_cards_number'] == null ? undefined : json['primary_cards_number'],
        'dependent_cards_number': json['dependent_cards_number'] == null ? undefined : json['dependent_cards_number'],
    };
}

export function ICardStatusMultiEmployersSummaryRecordDtoToJSON(json: any): ICardStatusMultiEmployersSummaryRecordDto {
    return ICardStatusMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function ICardStatusMultiEmployersSummaryRecordDtoToJSONTyped(value?: ICardStatusMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_active_cards': value['total_active_cards'],
        'total_pending_activation_cards': value['total_pending_activation_cards'],
        'total_closed_cards': value['total_closed_cards'],
        'total_lost_cards': value['total_lost_cards'],
        'percentage_of_active_cards': value['percentage_of_active_cards'],
        'primary_cards_number': value['primary_cards_number'],
        'dependent_cards_number': value['dependent_cards_number'],
    };
}

